module.exports = __webpack_public_path__ + "img/Group257.bb31d54c.png";